

<template>
<validation-provider :name="label" :rules="rule" v-slot="validationContext">
  <div class="card" @mouseover="isShown = true" @mouseleave="isShown = false" :class="{'invalid': getValidationState(validationContext) === false}">
    <div class="card-body card-img-back" style="background-color: #f1f0f9;">

      <Transition>
        <div class="profile-remove-logo d-flex justify-content-center align-items-center" v-if="isShown && isDeleteButtonShow && (profileImagePreview || profileImagePath)" @click="_removeLogo">
          <i class="bx bx-trash-alt"></i>
        </div>
      </Transition>
      <div v-bind:style="profileBackground"></div>
      <b-btn
          variant="primary"
          class="btn btn-primary mt-4 w-100 position-relative"
          v-if="isUploadButtonShow == true"
        >
          <i class="fa fa-upload mx-2"></i> Upload Photo
          <b-form-file
            class="profile-file-uploader"
            type="file"
            v-model="file"
            @click.native="_fileClick"
            @blur.native="_fileBlur"
            @change="_onFileChange"
            plain
          />
      </b-btn>
      <template v-if="shouldValidate">
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
      </template>
      <div class="validation-error">
        {{ errorMsgFileExtension }}
      </div>
    </div>
    
  </div>
  
</validation-provider>
</template>

<script>
import shortid from "shortid";
import _ from "lodash";

export default {
  name: 'profile-image-uploader',
  data(){
    return {
      dialogActive: false,
      isShown: false,
      file: null,
      profileImagePath: null,
      profileImagePreview: null,
      logo: {
        filename: null,
        type: null,
        base64: null
      },
      isDeleteButtonShow: true,
      isUploadButtonShow: false,
    }
  },
  computed: {
    profileBackground: {
      get(){
        var backgroundImage = null;
        if(this.profileImagePath){
          backgroundImage = this.profileImagePath;
        }
        
        if(this.profileImagePreview){
          backgroundImage = this.profileImagePreview
        } 

        return {
          width: '200px', /* Adjust the width as needed */
          height: '200px',
          borderRadius: '50%',
          overflow: 'hidden',
          position: 'relative',
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center', 
          margin: 'auto',
        };
      }
    }, 
    rule: {
      get(){
        if(this.shouldValidate){
          return this.isRequired ? 'required':'';
        } else {
          return '';
        }
      }
    },
    shouldValidate: {
      get(){
        return this.isRequired && (this.profileImagePath == null || this.profileImagePath == '');
      }
    }
  },
  props: ['label','isRequired','profileImageSrc','value', 'showDeleteButton', 'showUploadButton'],
  watch: {
    profileImageSrc(newVal){
      this.profileImagePreview = null;
      this.profileImagePath = newVal;
    },
  },
  methods: { 
    _fileClick(e){
      e.target.focus(); // Fix for safari not triggering blur.
      if(!this.dialogActive){
        this.dialogActive = true;
      } else {
        e.preventDefault();
      }
    },
    _fileBlur(){
      var _this = this;
      setTimeout(() => {
        _this.dialogActive = false;
      }, 2000);
    },
    _onFileChange(e){
      const reader = new FileReader();
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length){
        this.profileImagePreview = null;
        this.$emit("input", {
          filename: null,
          type: null,
          base64: null
        });
        return;
      }

      const allowedExtensions = ["jpg", "jpeg", "png", "svg"];
      const selectedFile = files[0];
      console.log("selectedFile: ", selectedFile);
      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.errorMsgFileExtension = 'Invalid image upload! Only [.jpg, .jpeg, .png .svg] are accepted.';
        console.log("Invalid file extension. Please select a valid image file.");
        return;
      }
      this.errorMsgFileExtension = '';

      this.profileImagePreview = URL.createObjectURL(selectedFile);

      reader.onloadend = () => {
        var base64Data = reader.result;
        this.logo.base64 = new Buffer.from(base64Data.replace(/^data:image\/[a-zA-Z+]+;base64,/, ''), 'base64');
        this.logo.type = base64Data.split(';')[0].split('/')[1];
        if(this.logo.type == 'svg+xml'){
          this.logo.type = 'svg';
        }
        this.logo.filename = `${shortid.generate()}.${this.logo.type}`;
        this.$emit("input", _.cloneDeep(this.logo));
      }
      reader.readAsDataURL(selectedFile);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    _removeLogo(){
      this.$emit("trigger-method");
      
      this.file = null;
      this.profileImagePath = require('@/assets/images/img-profile-placeholder.png');
      this.profileImagePreview = null;
    }
  },
  mounted(){
    this.profileImagePath = this.profileImageSrc;
    this.isDeleteButtonShow = this.showDeleteButton ?? true;
    this.isUploadButtonShow = this.showUploadButton ?? true;
    
  }
}
</script>

<style scoped>
.custom-body {
  width: 221.250px;
  height: 267.750px;
}

.profile-file-uploader {
    font-size: 20px;
    position: absolute;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
    width: 100%;
    height: 100%;
    left: 0;
}

.profile-remove-logo {
  cursor: pointer;
  border-radius: 50%;
  background: #BCBCBC;
  width: 30px;
  height: 30px;
  position: absolute;
  right: -15px;
  top: -15px;
  color: #E73092;
  transition: opacity 3s;
}

.profile-remove-logo.shown {
  opacity: 1;
}

.profile-remove-logo:hover {
  background: #E73092;
  color: #FFF;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.validation-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 87.5%;
  color: #f34e4e;
}

</style>